module.exports = __webpack_public_path__ + "img/8.d813277a.svg";